import React, { Component }     from 'react';
import { withRouter }           from 'react-router';
import { connect }              from 'react-redux';
import { ModalManager, Effect } from 'react-dynamic-modal';
import { MdVisibilityOff }      from 'react-icons/md';
import { MdVisibility }         from 'react-icons/md';
import { MdDelete }             from 'react-icons/md';
import { PubSubConstants }      from '../environment';
import DynamicModal             from '../../../Modal';
import { removeFetchData }      from '../../../../actions/pubsub/remove';
import { disableFetchData }     from '../../../../actions/pubsub/disable';

var apiHost = PubSubConstants.WebApiHost;

class ListDelete extends Component {
  constructor(props) {
    super(props);
    this.disable           = this.disable.bind(this);
    this.delete            = this.delete.bind(this);
    this.openDisableModal  = this.openDisableModal.bind(this);
    this.openDeleteModal   = this.openDeleteModal.bind(this);
  }
  
  disable() {
    var params = {
      process: this.props.item.Process,
      event: this.props.item.Event,
      disabled: !this.props.item.Disabled
    };

    this.props.fetchDataDisable(apiHost, params);
  }

  delete() {
    var params = {
      process: this.props.item.Process,
      event: this.props.item.Event
    };

    this.props.fetchDataRemove(apiHost, params);
  }

  openDisableModal() {
    let content = 
      <div>
        Are you sure you want to {this.props.item.Disabled ? 'enable' : 'disable'} <b>{this.props.item.Process} - {this.props.item.Event}?</b>
      </div>;
    
    let title = <span>{this.props.item.Disabled ? 'Enable' : 'Disable'} Site?</span>;
    ModalManager.open(
      <DynamicModal content={content} effect={Effect.ScaleUp} ok={this.disable} title={title} />
    );
  }

  openDeleteModal() {
    let content = 
      <div>
        Are you sure you want to delete <b>{this.props.item.Process} - {this.props.item.Event}?</b>
      </div>;
    
    let title = <span>Delete Site?</span>;
    ModalManager.open(
      <DynamicModal content={content} effect={Effect.ScaleUp} ok={this.delete} title={title} />
    );
  }
    
  render() {
    return (
      <tr>
        <td>
          <span className={this.props.item.Disabled ? 'strike-through' : ''}>
            {this.props.item.Process}
          </span>
        </td>
        <td>
          <span className={this.props.item.Disabled ? 'strike-through' : ''}>
            {this.props.item.Event}
          </span>
        </td>
        <td>
          <span className={this.props.item.Disabled ? 'strike-through' : ''}>
            {this.props.item.Owner}
          </span>
        </td>
        <td>
          <button onClick={this.openDisableModal}>
            { !this.props.item.Disabled ?
                <MdVisibilityOff size={24} />
              : <MdVisibility    size={24} />
            }
          </button>
        </td>
        <td>
          <button onClick={this.openDeleteModal}>
            <MdDelete size={24} />
          </button>
        </td>
      </tr>
      );
    }
}

const mapStateToProps = state => {
  return {
    remove: state.pubsub.remove.remove,
    removeHasErrored: state.pubsub.remove.removeHasErrored,
    disable: state.pubsub.disable.disable,
    disableHasErrored: state.pubsub.disable.disableHasErrored
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataRemove: (host, params) => dispatch(removeFetchData(host, params)),
    fetchDataDisable: (host, params) => dispatch(disableFetchData(host, params)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListDelete));
